module.exports = __webpack_public_path__ + "bg-login.ec712acdeee559f9c03c.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/HP/Documents/DESARROLLO/education-ee-web/src/assets/img/bg-login.png
// module id = ../../../../../src/assets/img/bg-login.png
// module chunks = styles